module.exports = __webpack_public_path__ + "spritesheet.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spritesheet.png
// module id = 133
// module chunks = 0